import React, {useCallback} from 'react';
import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
  useAdvancedMarkerRef
} from '@vis.gl/react-google-maps';
import { RouteurWifi } from 'components/CustomIcon/CustomIcon';

export const FeaturesClusterMarker = ({
  position,
  size,
  sizeAsText,
  onMarkerClick,
  clusterId,
  status,
}) => {
  const [markerRef, marker] = useAdvancedMarkerRef();
  const handleClick = useCallback(
    () => onMarkerClick && onMarkerClick(marker, clusterId),
    [onMarkerClick, marker, clusterId]
  );
  const markerSize = Math.floor(54 + Math.sqrt(size) * 2);
  return (
    <AdvancedMarker
      ref={markerRef}
      position={position}
      zIndex={size}
      onClick={handleClick}
      className={'marker cluster'}
      style={{width: markerSize, height: markerSize, background:status === 'ok' ? '#91C73C' : status === 'ko' ? 
        '#f44336' : status === 'kok' ? 
        'linear-gradient(180deg,rgba(145, 199, 60, 1) 0%, rgba(244, 67, 54, 1) 100%)' : 
        '#605f70'}}
      anchorPoint={AdvancedMarkerAnchorPoint.CENTER}>
      <RouteurWifi />
      <span>{sizeAsText}</span>
    </AdvancedMarker>
  );
};
